export const DropboxClaimedHosts = [
  'dropbox.com',
  'www.dropbox.com',
  'paper.dropbox.com',
];
